/**
 * Feature-flag gate for the V2 admin module.
 *
 * Wraps every V2 admin route. If VITE_ADMIN_V2 is on → render children.
 * If off → redirect the user to the legacy admin Properties tab. This way
 * V2 routes never 404 in dev / prod when the flag is off; they just send
 * the user to the working legacy view.
 */
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import {
  isAdminV2Enabled,
  isOwnerPortalSectionsEnabled,
} from "@/lib/featureFlags";

export function FeatureFlagGate({
  children,
  // The free-tier owner sections ship behind a second flag. Hiding them in the
  // nav is not a gate: a bookmark or a shared link still renders the page.
  // Routes that belong to that group pass `ownerSection` so the rollout switch
  // actually switches them off.
  ownerSection = false,
}: {
  children: ReactNode;
  ownerSection?: boolean;
}) {
  // Property owners may use V2 property routes when the flag is on; data is scoped via RLS / hooks.
  if (!isAdminV2Enabled()) {
    return <Navigate to="/admin?tab=properties" replace />;
  }
  if (ownerSection && !isOwnerPortalSectionsEnabled()) {
    return <Navigate to="/admin/properties" replace />;
  }
  return <>{children}</>;
}
